import styled from "styled-components";

interface PropsArgs {
  bg?: string;
  color?: string;
  border?: string;
  borderColor?: string;
  hoverborder?: string;
  padding?: string;
  hoverColor?: string;
  hoverBg?: string;
  buttonWidth?: string;
}

interface FlexedAllAlignedProps {
  gap?: string;
  top?: string;
}

export const Button = styled.button<PropsArgs>`
  background: ${(p) => p.bg || "transparent"};
  color: ${(p) => p.color || "var(--text-black)"};
  border: ${(p) => p.border || "none"};
  padding: ${(p) => p.padding || "0.7rem 1.5rem"};
  min-width: ${(p) => p.buttonWidth || "100px"};
  min-height: 40px;
  font-size: 16px;
  font-weight: 600;
  backdrop-filter: blur(12px);

  transition: all 0.8s;
  &:hover {
    color: ${(p) => p.hoverColor || "var(--sixthPurple)"};
    background: ${(p) => p.hoverBg || "var(--sixthLightPurple)"};
    border-color: ${(p) => p.borderColor || "none"};
  }
`;

export const NavButton = styled.div<PropsArgs>`
  background: ${(p) => p.bg || "transparent"};
  color: ${(p) => p.color || "#ffffff80"};
  border: ${(p) => p.border || "none"};
  padding: ${(p) => p.padding || "0.5rem 1.2rem"};
  position: relative;
  margin: 0 2px;
  overflow: hidden;
  cursor: pointer;
  text-align: center;
  transition: all 0.45s;

  font-weight: 600;
  width: 100%;
  display: flex;
  align-items: center;
  > a,>p {
    font-size: 16px;
    line-height: 1.6em;
    margin:0;
  }
  &:hover {
    color: ${(p) => p.color || "#ffffffff"};
  }
`;
export const FlexedAllAligned = styled.div<FlexedAllAlignedProps>`
  display: flex;
  align-items: center;
  position: relative;
  gap: ${(p) => p.gap || 0};
  top: ${(p) => p.top || 0};
`;

export const GenericTextHeader = styled.h1`
  font-size: 45px;
  font-weight: 700;
`;

export const Centered = styled.div`
  max-width: 966px;
  margin: 4rem auto;

  > h1 {
    font-size: 36px;
    text-align: center;
  }

  > h2 {
    font-size: 30px;
    font-weight: 500;
    text-align: center;
  }

  @media (max-width: 728px) {
    width: 90%;
  }
`;

export const PriceCardFlex = styled.div`
  display: flex;
  justify-content: Center;
  gap: 40px;
  margin: 3rem 0 0 0;

  > div {
    width: 45%;
    border: 1px solid #8c30f5;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 25%);
    padding: 10px 10px 20px 10px;
    border-radius: 10px;
    text-align: center;
    background: linear-gradient(0deg, #18191f, #18191f);

    > h5 {
      font-size: 32px;
      font-weight: 500;
      line-height: 48px;
      letter-spacing: 0em;
      text-align: left;

      > span {
        font-size: 16px;
        font-weight: 600;
        line-height: 33px;
        letter-spacing: 0em;
        text-align: left;
      }
    }

    > h3 {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
    }

    span {
      color: #757575;
    }

    > div {
      display: flex;
      align-items: Center;
      justify-content: Center;
      gap: 5px;
      padding: 5px 0;
      font-size: 15px;
    }
  }

  @media (max-width: 728px) {
    flex-direction: column;

    > div {
      width: 95%;
      padding: 10px 2.5% 30px 2.5%;
    }
  }
`;
